import React, { useCallback, useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Flex,
  Image,
  Table,
  Select,
  Button,
  Divider,
  GetProps,
  DatePicker,
  Typography,
  ConfigProvider,
  type FormProps,
  type TableColumnsType,
} from "antd";
import "dayjs/locale/vi";
import dayjs from "dayjs";
import moment from "moment";
import "./Report.scss";
import { formatPrice, handleGetUrlGuide } from "../../utils/helpers";
import IconFileExport from "../../components/Icons/IconFileExport";
import IconExportExcel from "../../components/Icons/IconExportExcel";
import IconExclamationCircle from "../../assets/images/ExclamationCircle.svg";
import { DataReport, TimeRouteData, ValueOptions } from "../../types/report";
import { DEFAULT_PAGE_SIZE } from "antd/es/table/hooks/usePagination";
import { Constant } from "../../config/constant";
import { toast } from "react-toastify";
import { getListDepartTimeByRouteAPI, getListRouteAPI } from "../../api/report";
import { RouteItemProps } from "../../types";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  setFilterDepartTime,
  setFilterRangeDate,
  setFilterReportFor,
  setFilterRoute,
  setListTimeRoute,
  getListReportFeeDepart,
  getListReportFeeDepartExcel,
  setPerPage
} from "../../redux/slice/report/reportFeeDepartSlice";
import ExcelJS from "exceljs";
import { IExcelColumn } from "antd-table-saveas-excel/app";
import TutorialsVideo from "../../components/TutorialsVideo";

dayjs.locale("vn");
const { RangePicker } = DatePicker;
type RangePickerProps = GetProps<typeof DatePicker.RangePicker>;

export enum TypeOptions {
  report_detail = "detailed_report",
  report_total = "synthesis_report",
}

export const optionsOptions = [
  {
    value: TypeOptions.report_detail,
    label: "Báo cáo chi tiết",
  },
  {
    value: TypeOptions.report_total,
    label: "Báo cáo tổng hợp",
  },
];

type FieldType = {
  range_date_report: string;
  route_id: number | string;
  depart_time: number | string;
  options: string;
};

const ReportFeeDepart = () => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const [page, setPage] = useState<number>(1);
  const [timeReport, setTimeReport] = useState<RangePickerProps["value"]>();
  const [optionsRoute, setOptionsRoute] = useState<ValueOptions[]>([]);
  const [typeReportFor, setTypeReportFor] = useState<TypeOptions>(
    TypeOptions.report_detail
  );

  const limit_pagination: any = window.localStorage.getItem("limit_pagination");
  const limitPagination = isNaN(Number(limit_pagination))
    ? Constant.PAGE_SIZE
    : Number(limit_pagination);

  const watchOptions = Form.useWatch("options", form);
  const watchRoute = Form.useWatch("route_id", form);
  const watchTimeRoute = Form.useWatch("depart_time", form);

  useEffect(() => {
    setTypeReportFor(listFilter?.options as TypeOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pagination = useAppSelector(
    (state) => state?.reportFeeDepart?.pagination
  );
  const listReport = useAppSelector(
    (state) => state?.reportFeeDepart?.listReport
  );
  const loadingListReport = useAppSelector(
    (state) => state?.reportFeeDepart?.loading
  );
  const totalPriceDepartFee = useAppSelector(
    (state) => state?.reportFeeDepart?.total_price_depart_fee
  );
  const totalTrip = useAppSelector(
    (state) => state?.reportFeeDepart?.total_trip
  );
  const listTimeRoute = useAppSelector(
    (state) => state?.reportFeeDepart?.listTimeRoute
  );
  const listFilter = useAppSelector((state) => state?.reportFeeDepart?.filter);
  const listTutorials = useAppSelector(
    (state) => state?.tutorials?.listTutorials
  );
  const handleGetListRoute = async () => {
    const response = await getListRouteAPI();
    if (response) {
      const listRoute: ValueOptions[] = response?.data?.data?.map(
        (route: RouteItemProps) => ({
          value: route?.id,
          label: `${route?.depart_point} - ${route?.arrive_point}`,
        })
      );
      listRoute.unshift({
        value: "",
        label: "Tất cả các tuyến",
      });
      setOptionsRoute(listRoute);
    }
  };

  const handleChangeRoute = async (value: number | string) => {
    const response = await getListDepartTimeByRouteAPI(value);
    if (response) {
      const listTimeRoute: ValueOptions[] = response?.data?.data?.map(
        (time: TimeRouteData) => ({
          value: dayjs(time?.depart_time, "HH:mm").format("HH:mm"),
          label: dayjs(time?.depart_time, "HH:mm").format("HH:mm"),
        })
      );
      listTimeRoute.unshift({
        value: "",
        label: "Tất cả",
      });
      dispatch(setFilterRoute(value));
      dispatch(setListTimeRoute(listTimeRoute));
      dispatch(setFilterDepartTime(""));
      form.setFieldValue("depart_time", { value: "", label: "Giờ đi" });
    }
  };

  useEffect(() => {
    handleGetListRoute();
  }, []);

  const onChangePage = async (page: number, pageSize: number) => {
    if (pagination?.per_page !== pageSize) {
      setPage(Constant.DEFAULT_PAGE);
      dispatch(setPerPage(pageSize));
    } else {
      setPage(page);
    }
    await dispatch(
      getListReportFeeDepart({
        from: dayjs(timeReport?.[0]).format("YYYY-MM-DD"),
        to: dayjs(timeReport?.[1]).format("YYYY-MM-DD"),
        options: watchOptions,
        route_id: watchRoute?.label ? watchRoute?.value : watchRoute,
        depart_time: watchTimeRoute?.label
          ? watchTimeRoute?.value
          : watchTimeRoute,
        page: pagination?.per_page !== pageSize ? Constant.DEFAULT_PAGE : page,
        limit: pageSize,
      })
    );
  };

  const onFinish: FormProps<any>["onFinish"] = async () => {
    if (watchOptions === TypeOptions.report_detail) {
      setTypeReportFor(TypeOptions.report_detail);
    } else {
      setTypeReportFor(TypeOptions.report_total);
    }
    setPage(Constant.DEFAULT_PAGE);
    const response = await dispatch(
      getListReportFeeDepart({
        from: dayjs(timeReport?.[0]).format("YYYY-MM-DD"),
        to: dayjs(timeReport?.[1]).format("YYYY-MM-DD"),
        options: watchOptions,
        route_id: watchRoute?.label ? watchRoute?.value : watchRoute,
        depart_time: watchTimeRoute?.label
          ? watchTimeRoute?.value
          : watchTimeRoute,
        page: Constant.DEFAULT_PAGE,
        limit: pagination?.per_page || limitPagination,
      })
    );
    if (response?.payload?.success) {
      toast.success(response?.payload?.message);
    }
  };

  const handleGetListReportBegin = async () => {
    setPage(Constant.DEFAULT_PAGE);
    if (listFilter?.from && listFilter?.to && listFilter?.options) {
      await dispatch(
        getListReportFeeDepart({
          from: dayjs(listFilter?.from).format("YYYY-MM-DD"),
          to: dayjs(listFilter?.to).format("YYYY-MM-DD"),
          options: listFilter?.options,
          route_id: listFilter?.route_id,
          depart_time: listFilter?.depart_time,
          page: Constant.DEFAULT_PAGE,
          limit: pagination?.per_page || limitPagination,
        })
      );
    }
  };

  useEffect(() => {
    handleGetListReportBegin();
    if (listFilter?.from && listFilter?.to) {
      setTimeReport([
        dayjs(listFilter?.from, "YYYY-MM-DD"),
        dayjs(listFilter?.to, "YYYY-MM-DD"),
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columnsReportDetail: TableColumnsType<DataReport> = [
    {
      title: "Tuyến",
      dataIndex: "route",
      render: (route) => (
        <Typography.Text className="fs-16 text-color fw-500">{`${route?.depart_point} - ${route?.arrive_point}`}</Typography.Text>
      ),
      sorter: (a, b) =>
        `${a?.route?.depart_point} - ${a?.route?.arrive_point}`.localeCompare(
          `${b?.route?.depart_point} - ${b?.route?.arrive_point}`
        ),
    },
    {
      title: "Ngày đi",
      dataIndex: "depart_date",
      render: (depart_date) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {depart_date ? moment(depart_date).format("DD/MM/YYYY") : ""}
        </Typography.Text>
      ),
      sorter: (a, b) => {
        if (
          a &&
          a?.depart_date &&
          a?.depart_date.length &&
          b &&
          b?.depart_date &&
          b?.depart_date.length
        ) {
          return a?.depart_date.localeCompare(b?.depart_date);
        } else if (a && a?.depart_date && a?.depart_date?.length) {
          // that means be has null license_class, so a will come first.
          return -1;
        } else if (b && b?.depart_date && b?.depart_date?.length) {
          // that means a has null license_class so b will come first.
          return 1;
        }
        // both license_class has null value so there will be no order change.
        return 0;
      },
    },
    {
      title: "Giờ đi",
      dataIndex: "depart_time",
      render: (depart_time) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {depart_time ? moment(depart_time, "HH:mm").format("HH:mm") : ""}
        </Typography.Text>
      ),
    },
    {
      title: "Loại xe",
      dataIndex: "bus_type",
      render: (bus_type) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {bus_type ? bus_type : ""}
        </Typography.Text>
      ),
    },
    {
      title: "Tỉ lệ lấp đầy",
      dataIndex: "",
      render: (_, record) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {`${record?.count_pick_up ? record?.count_pick_up : 0}/${
            record?.seat_number ? record?.seat_number : 0
          }`}
        </Typography.Text>
      ),
    },
    {
      title: "Phí xuất bến",
      dataIndex: "depart_fee",
      align: "right",
      render: (depart_fee) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {depart_fee ? formatPrice(depart_fee, 0, ",") : 0}
        </Typography.Text>
      ),
    },
  ];
  const columnsReportTotal: TableColumnsType<DataReport> = [
    {
      title: "Tuyến",
      dataIndex: "route",
      render: (route) => (
        <Typography.Text className="fs-16 text-color fw-500">{`${route?.depart_point} - ${route?.arrive_point}`}</Typography.Text>
      ),
      sorter: (a, b) =>
        `${a?.route?.depart_point} - ${a?.route?.arrive_point}`.localeCompare(
          `${b?.route?.depart_point} - ${b?.route?.arrive_point}`
        ),
    },
    {
      title: "Phí xuất bến / chuyến",
      dataIndex: "depart_fee",
      align: "right",
      render: (depart_fee) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {depart_fee ? formatPrice(depart_fee, 0, ",") : 0}
        </Typography.Text>
      ),
    },
    {
      title: "Số lượng chuyến",
      dataIndex: "total_trip",
      align: "right",
      render: (total_trip) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {total_trip ? formatPrice(total_trip, 0, ",") : 0}
        </Typography.Text>
      ),
    },
    {
      title: "Tổng phí xuất bến",
      dataIndex: "total_depart_fee",
      align: "right",
      render: (total_depart_fee) => (
        <Typography.Text className="fs-16 text-color fw-500">
          {total_depart_fee ? formatPrice(total_depart_fee, 0, ",") : 0}
        </Typography.Text>
      ),
    },
  ];

  const handleGetLabelRoute = (value: number | string) => {
    const routeCurrent = optionsRoute?.find((route) => route?.value === value);
    return routeCurrent?.label || "Tất cả các tuyến";
  };

  const handleGetLabelTimeRoute = (value: string) => {
    const timeCurrent = listTimeRoute.find((time) => time.value === value);
    return timeCurrent?.label || "Tất cả";
  };

  const handleGetLabelTypeReport = (value: string) => {
    const typeCurrent = optionsOptions?.find((type) => type?.value === value);
    return typeCurrent?.label;
  };

  const onChangeTimeReport = (value: RangePickerProps["value"]) => {
    setTimeReport(value);
    dispatch(setFilterRangeDate(value));
  };

  const onChangeTimeRoute = (value: number | string) => {
    dispatch(setFilterDepartTime(value));
  };

  const onChangeReportFor = (value: TypeOptions) => {
    dispatch(setFilterReportFor(value));
  };

  const columnsReportDetailExcel: IExcelColumn[] = [
    {
      title: "Tuyến",
      dataIndex: "route",
      width: 40,
      __excelTitle__: "Tuyến",
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
      },
    },
    {
      title: "Ngày đi",
      dataIndex: "depart_date",
      __excelTitle__: "Ngày đi",
      width: 15,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
      },
    },
    {
      title: "Giờ đi",
      dataIndex: "depart_time",
      __excelTitle__: "Giờ đi",
      width: 15,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
      },
    },
    {
      title: "Loại xe",
      dataIndex: "bus_type",
      __excelTitle__: "Loại xe",
      width: 25,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
      },
    },
    {
      title: "Tỷ lệ lấp đầy",
      dataIndex: "seat_number",
      __excelTitle__: "Tỷ lệ lấp đầy",
      width: 15,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
      },
    },
    {
      title: "Phí xuất bến",
      dataIndex: "depart_fee",
      __cellType__: "TypeNumeric",
      __excelTitle__: "Phí xuất bến",
      __numFmt__: "#,##0",
      width: 20,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
  ];
  const columnsReportTotalExcel: IExcelColumn[] = [
    {
      title: "Tuyến",
      dataIndex: "route",
      width: 40,
      __excelTitle__: "Tuyến",
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
      },
    },
    {
      title: "Phí xuất bến / chuyến",
      dataIndex: "depart_fee",
      __cellType__: "TypeNumeric",
      __excelTitle__: "Phí xuất bến / chuyến",
      __numFmt__: "#,##0",
      width: 30,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
    {
      title: "Số lượng chuyến",
      dataIndex: "total_trip",
      __cellType__: "TypeNumeric",
      __excelTitle__: "Số lượng chuyến",
      __numFmt__: "#,##0",
      width: 20,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
    {
      title: "Tổng phí xuất bến",
      dataIndex: "total_depart_fee",
      __cellType__: "TypeNumeric",
      __excelTitle__: "Tổng phí xuất bến",
      __numFmt__: "#,##0",
      width: 20,
      __style__: {
        fontName: "Times New Roman",
        fontSize: 14,
        border: true,
        borderColor: "black",
        h: "right",
      },
    },
  ];

  const handleExportExcel = async () => {
    const response: any = await dispatch(
      getListReportFeeDepartExcel({
        from: dayjs(timeReport?.[0]).format("YYYY-MM-DD"),
        to: dayjs(timeReport?.[1]).format("YYYY-MM-DD"),
        route_id: watchRoute?.label ? watchRoute?.value : watchRoute,
        depart_time: watchTimeRoute?.label
          ? watchTimeRoute?.value
          : watchTimeRoute,
        options: watchOptions,
      })
    );
    if (!response?.error) {
      const listData = response?.payload?.data;
      const columnsExport =
        watchOptions === TypeOptions.report_detail
          ? columnsReportDetailExcel
          : columnsReportTotalExcel;
      const totalPriceDepartFee = response?.payload?.total_price_depart_fee;
      const totalTrip = response?.payload?.total_trip;

      const listDataExcel =
        listData?.length > 0
          ? watchOptions === TypeOptions.report_detail
            ? listData?.map((report: DataReport) => ({
                route: `${report?.route?.depart_point} - ${report?.route?.arrive_point}`,
                depart_date: report?.depart_date
                  ? `${moment(report?.depart_date).format("DD/MM/YYYY")}`
                  : "",
                depart_time: report?.depart_time
                  ? `${moment(report?.depart_time, "HH:mm").format("HH:mm")}`
                  : "",
                bus_type: report?.bus_type ? report?.bus_type : "",
                seat_number: `${
                  report?.count_pick_up ? report?.count_pick_up : 0
                }/${report?.seat_number ? report?.seat_number : 0}`,
                depart_fee: report?.depart_fee ? Number(report?.depart_fee) : 0,
              }))
            : listData?.map((report: DataReport) => ({
                route: `${report?.route?.depart_point} - ${report?.route?.arrive_point}`,
                depart_fee: report?.depart_fee ? Number(report?.depart_fee) : 0,
                total_trip: report?.total_trip ? Number(report?.total_trip) : 0,
                total_depart_fee: report?.total_depart_fee
                  ? Number(report?.total_depart_fee)
                  : 0,
              }))
          : [];
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Báo cáo phí xuất bến");
      const header = columnsExport.map((col) => ({
        header: col.title,
        key: col.dataIndex as string,
      }));
      worksheet.columns = header;
      columnsExport.forEach((col, index) => {
        worksheet.getColumn(index + 1).width = col.width || 15;
        worksheet.getColumn(index + 1).alignment = {
          horizontal:
            (col?.__style__?.h as
              | "center"
              | "left"
              | "right"
              | "fill"
              | "justify") || "left",
          vertical: "middle",
        };
        worksheet.getColumn(index + 1).numFmt = col.__numFmt__ || "general";
      });
      worksheet.addRows(listDataExcel);
      worksheet.getRow(1).font = {
        name: "Times New Roman",
        size: 12,
        bold: true,
      };
      if (watchOptions === TypeOptions.report_total) {
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          if (colNumber < 10) {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "3AB54A" },
            };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          }
        });
      } else {
        worksheet.getRow(1).eachCell((cell, colNumber) => {
          if (colNumber < 7) {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "3AB54A" },
            };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
          }
        });
      }
      let firstRowHasData = false;
      worksheet.getRow(1).eachCell((cell, colNumber) => {
        if (cell.value) {
          firstRowHasData = true;
          return;
        }
      });
      if (firstRowHasData) {
        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
          if (rowNumber > 1) {
            row.eachCell((cell) => {
              cell.font = { name: "Times New Roman", size: 12 };
              cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            });
          }
        });
      } else {
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) {
            let hasData = false;
            row.eachCell((cell) => {
              if (cell.value) {
                hasData = true;
                return;
              }
            });
            if (hasData) {
              row.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
              };
            }
          }
        });
      }
      const startColumnIndex = 1;

      const subLastRow = worksheet.addRow([]);
      subLastRow.getCell(1).value = "TỔNG (VND)";
      subLastRow.getCell(1).alignment = {
        vertical: "middle",
        horizontal: "left",
      };
      subLastRow.getCell(1).font = {
        name: "Times New Roman",
        size: 14,
        bold: true,
      };
      const endColumnIndexTotal =
        watchOptions === TypeOptions.report_detail
          ? startColumnIndex + columnsExport.length - 2
          : startColumnIndex + columnsExport.length - 3;
      worksheet.mergeCells(
        subLastRow.number,
        1,
        subLastRow.number,
        endColumnIndexTotal
      );
      if (watchOptions === TypeOptions.report_total) {
        subLastRow.getCell(3).value = totalTrip;
        subLastRow.getCell(4).value = totalPriceDepartFee;
      } else {
        subLastRow.getCell(6).value = totalPriceDepartFee;
      }
      subLastRow.eachCell((cell) => {
        cell.font = { name: "Times New Roman", size: 14, bold: true };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      const lastRow = worksheet.addRow([]);
      lastRow.getCell(1).value = "@Bản quyền thuộc nhà xe Carlink";
      lastRow.getCell(1).alignment = {
        vertical: "middle",
        horizontal: "left",
      };
      lastRow.getCell(1).font = {
        name: "Times New Roman",
        size: 14,
        bold: true,
      };

      const endColumnIndex = startColumnIndex + columnsExport.length - 1;
      worksheet.mergeCells(lastRow.number, 1, lastRow.number, endColumnIndex);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Báo cáo phí xuất bến.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };
  const filterOption = (
    input: string,
    option?: {
      label?: any;
      value?: any;
    }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const systemConfig = useAppSelector((state) => state.systemConfig?.result);
  const disabledDaysDate = useCallback(
    (current: any, { from }: any) => {
      if (from) {
        return (
          Math.abs(current.diff(from, "days")) >=
          systemConfig?.export_report_month
        );
      }
      return false;
    },
    [systemConfig?.export_report_month]
  );
  return (
    <div className="Report bg-white">
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          range_date_report: [
            listFilter?.from
              ? dayjs(listFilter?.from, "DD/MM/YYYY")
              : undefined,
            listFilter?.to ? dayjs(listFilter?.to, "DD/MM/YYYY") : undefined,
          ],
          options: listFilter?.options,
          route_id:
            listFilter?.route_id === ""
              ? { value: listFilter?.route_id, label: "Chọn tuyến" }
              : listFilter?.route_id,
          depart_time:
            listFilter?.depart_time === ""
              ? { value: "", label: "Giờ đi" }
              : listFilter?.depart_time,
        }}
      >
        <Row gutter={12}>
          <Col className="Report__typeDateReport">
            <Form.Item className="required" label="Khoảng thời gian">
              <Select placeholder="Theo ngày khởi hành" disabled={true} />
            </Form.Item>
          </Col>
          <Col className="Report__rangeDateReport">
            <Form.Item<FieldType>
              name="range_date_report"
              rules={[
                { required: true, message: "Vui lòng chọn khoảng thời gian" },
              ]}
            >
              <RangePicker
                format="DD/MM/YYYY"
                disabledDate={disabledDaysDate}
                onChange={onChangeTimeReport}
                popupClassName="Report__timeReport__picker"
                placeholder={["Từ ngày", "Đến ngày"]}
              />
            </Form.Item>
          </Col>
          <Col className="Report__typeDateReport">
            <Form.Item<FieldType>
              className="required"
              name="options"
              label="Loại báo cáo"
              rules={[
                { required: true, message: "Vui lòng chọn loại báo cáo" },
              ]}
            >
              <Select
                onChange={onChangeReportFor}
                placeholder="Loại báo cáo"
                options={optionsOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        <Flex align="center" gap={"small"} className="mb-24">
          <Image
            preview={false}
            width={20}
            height={20}
            className="d-flex"
            src={IconExclamationCircle}
            alt="Icon Exclamation Circle"
          />
          <Typography.Text className="fs-14 fw-500 text-color">
            Vui lòng chọn các thông tin bên trên để xem báo cáo
          </Typography.Text>
        </Flex>
        <Typography.Text className="fs-6 fw-500 text-color d-block mb-8">
          Bộ lọc nâng cao
        </Typography.Text>
        <Flex gap={"small"}>
          <Form.Item<FieldType> className="Report__route" name="route_id">
            <Select
              onChange={handleChangeRoute}
              options={optionsRoute}
              popupClassName="Report__popup"
              showSearch
              filterOption={filterOption}
            />
          </Form.Item>
          {watchOptions === TypeOptions.report_detail && (
            <Form.Item<FieldType>
              className="Report__timeRoute"
              name="depart_time"
            >
              <Select onChange={onChangeTimeRoute} options={listTimeRoute} />
            </Form.Item>
          )}
        </Flex>
        <Flex align="center" justify="space-between">
          <Form.Item className="Report__submit">
            <ConfigProvider theme={{ token: { colorPrimary: "#435869" } }}>
              <Button
                disabled={
                  (timeReport?.length === 2 ||
                    (listFilter?.from && listFilter?.to)) &&
                  watchOptions
                    ? false
                    : true
                }
                className="d-flex align-items-center h-auto"
                type="primary"
                htmlType="submit"
              >
                <IconFileExport width={16} height={16} />
                Xem báo cáo
              </Button>
            </ConfigProvider>
          </Form.Item>
          <TutorialsVideo url_youtube={handleGetUrlGuide(listTutorials, 2)} />
        </Flex>
        <Divider />
        <Flex>
          <ConfigProvider theme={{ token: { colorPrimary: "#435869" } }}>
            <Button
              ghost
              disabled={
                (timeReport?.length === 2 ||
                  (listFilter?.from && listFilter?.to)) &&
                watchOptions
                  ? false
                  : true
              }
              onClick={handleExportExcel}
              className={`Report__exportExcel d-flex align-items-center mr-12 h-auto ${
                (timeReport?.length === 2 ||
                  (listFilter?.from && listFilter?.to)) &&
                watchOptions
                  ? ""
                  : "disabled"
              }`}
              type="primary"
            >
              <IconExportExcel
                color={`${
                  (timeReport?.length === 2 ||
                    (listFilter?.from && listFilter?.to)) &&
                  watchOptions
                    ? "#435869"
                    : "#949494"
                }`}
                width={16}
                height={16}
              />
              Xuất Excel
            </Button>
          </ConfigProvider>
        </Flex>
        <Typography.Text className="d-block text-color-gray-3A3A3A fs-18 fw-600 mt-24 mb-8">
          Báo cáo phí xuất bến (Theo ngày khởi hành)
        </Typography.Text>
        <Flex wrap="wrap" align="center" className="Report__filter">
          {timeReport && (
            <Flex align="center" className="Report__filter__item">
              <Typography.Text className="d-block fs-16 fw-500">
                Từ ngày:
              </Typography.Text>
              <Typography.Text className="d-block fs-16 fw-600">
                {dayjs(timeReport?.[0]).format("DD/MM/YYYY")}
              </Typography.Text>
            </Flex>
          )}
          {timeReport && (
            <Flex align="center" className="Report__filter__item">
              <Typography.Text className="d-block fs-16 fw-500">
                Đến ngày:
              </Typography.Text>
              <Typography.Text className="d-block fs-16 fw-600">
                {dayjs(timeReport?.[1]).format("DD/MM/YYYY")}
              </Typography.Text>
            </Flex>
          )}
          {watchOptions && (
            <Flex align="center" className="Report__filter__item">
              <Typography.Text className="d-block fs-16 fw-500">
                Loại báo cáo:
              </Typography.Text>
              <Typography.Text className="d-block fs-16 fw-600">
                {handleGetLabelTypeReport(watchOptions)}
              </Typography.Text>
            </Flex>
          )}
          <Flex align="center" className="Report__filter__item">
            <Typography.Text className="d-block fs-16 fw-500">
              Tuyến:
            </Typography.Text>
            <Typography.Text className="d-block fs-16 fw-600">
              {handleGetLabelRoute(watchRoute)}
            </Typography.Text>
          </Flex>
          <Flex align="center" className="Report__filter__item">
            <Typography.Text className="d-block fs-16 fw-500">
              Giờ đi:
            </Typography.Text>
            <Typography.Text className="d-block fs-16 fw-600">
              {handleGetLabelTimeRoute(watchTimeRoute)}
            </Typography.Text>
          </Flex>
        </Flex>
      </Form>
      <Table
        className="Report__table"
        locale={{
          triggerDesc: "Sắp xếp tăng dần",
          triggerAsc: "Hủy sắp xếp",
          cancelSort: "Sắp xếp giảm dần",
        }}
        pagination={{
          total: pagination?.total,
          current: page,
          pageSize: pagination?.per_page ?? DEFAULT_PAGE_SIZE,
          position: ["bottomRight"],
          onChange: onChangePage,
          showSizeChanger: true,
        }}
        dataSource={listReport?.length > 0 ? listReport : []}
        loading={loadingListReport}
        columns={
          typeReportFor === TypeOptions.report_detail
            ? columnsReportDetail
            : columnsReportTotal
        }
        summary={(pageData) => {
          return (
            listReport?.length > 0 &&
            page === pagination?.last_page && (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell
                    index={0}
                    colSpan={
                      typeReportFor === TypeOptions.report_detail ? 5 : 2
                    }
                  >
                    <Flex align="center" gap="middle">
                      <Typography.Text className="text-color-default fw-700 fs-16">
                        TỔNG
                      </Typography.Text>
                      <Typography.Text className="text-color-default fw-500 fs-16">
                        (VND)
                      </Typography.Text>
                    </Flex>
                  </Table.Summary.Cell>
                  {typeReportFor === TypeOptions.report_total && (
                    <Table.Summary.Cell align="right" index={2}>
                      <Typography.Text className="text-color-default text-end fw-700 fs-16">
                        {totalTrip ? formatPrice(totalTrip, 0, ",") : 0}
                      </Typography.Text>
                    </Table.Summary.Cell>
                  )}
                  <Table.Summary.Cell
                    align="right"
                    index={typeReportFor === TypeOptions.report_detail ? 5 : 3}
                  >
                    <Typography.Text className="text-color-default text-end fw-700 fs-16">
                      {totalPriceDepartFee
                        ? formatPrice(totalPriceDepartFee, 0, ",")
                        : 0}
                    </Typography.Text>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </>
            )
          );
        }}
      />
    </div>
  );
};

export default ReportFeeDepart;
